"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.eigsDependencies = void 0;

var _dependenciesAbsGenerated = require("./dependenciesAbs.generated.js");

var _dependenciesAddGenerated = require("./dependenciesAdd.generated.js");

var _dependenciesAddScalarGenerated = require("./dependenciesAddScalar.generated.js");

var _dependenciesAtanGenerated = require("./dependenciesAtan.generated.js");

var _dependenciesBignumberGenerated = require("./dependenciesBignumber.generated.js");

var _dependenciesCosGenerated = require("./dependenciesCos.generated.js");

var _dependenciesEqualGenerated = require("./dependenciesEqual.generated.js");

var _dependenciesInvGenerated = require("./dependenciesInv.generated.js");

var _dependenciesMatrixGenerated = require("./dependenciesMatrix.generated.js");

var _dependenciesMultiplyGenerated = require("./dependenciesMultiply.generated.js");

var _dependenciesMultiplyScalarGenerated = require("./dependenciesMultiplyScalar.generated.js");

var _dependenciesSinGenerated = require("./dependenciesSin.generated.js");

var _dependenciesSubtractGenerated = require("./dependenciesSubtract.generated.js");

var _dependenciesTypedGenerated = require("./dependenciesTyped.generated.js");

var _factoriesAny = require("../../factoriesAny.js");

/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
var eigsDependencies = {
  absDependencies: _dependenciesAbsGenerated.absDependencies,
  addDependencies: _dependenciesAddGenerated.addDependencies,
  addScalarDependencies: _dependenciesAddScalarGenerated.addScalarDependencies,
  atanDependencies: _dependenciesAtanGenerated.atanDependencies,
  bignumberDependencies: _dependenciesBignumberGenerated.bignumberDependencies,
  cosDependencies: _dependenciesCosGenerated.cosDependencies,
  equalDependencies: _dependenciesEqualGenerated.equalDependencies,
  invDependencies: _dependenciesInvGenerated.invDependencies,
  matrixDependencies: _dependenciesMatrixGenerated.matrixDependencies,
  multiplyDependencies: _dependenciesMultiplyGenerated.multiplyDependencies,
  multiplyScalarDependencies: _dependenciesMultiplyScalarGenerated.multiplyScalarDependencies,
  sinDependencies: _dependenciesSinGenerated.sinDependencies,
  subtractDependencies: _dependenciesSubtractGenerated.subtractDependencies,
  typedDependencies: _dependenciesTypedGenerated.typedDependencies,
  createEigs: _factoriesAny.createEigs
};
exports.eigsDependencies = eigsDependencies;